import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { $api } from "../../../../../../../../helpers/$api";
import { Util } from "../../../../../../../../helpers/util";
import { SuccessModal } from "../../../../../../../modals/success-modal/success.modal";
import backtick from "../../../../../assets/backtick.svg";

const SaveNowFixed = ({ setMenu, payment }) => {
  let payload = Util.get("create_fixed_plan");
  const { currency } =
    payload.payment_method === "dollar_wallet" ? "$" : Util.getCurrency();
  const [ovest, setOvest] = useState("0.00");
  const [saving, setSaving] = useState(false);
  const [show, setShow] = useState(false);
  let isCard = false;

  if (payment) {
    payload = Util.set("create_fixed_plan", { ...payload, ...payment });
    isCard = payment.payment_method === "card";
  }

  const handleSaveClick = async () => {
    try {
      if (!saving) {
        setSaving(true);

        await $api.user.createSavestPlan(payload);
        toast.success("saving plan initiated");
        setShow(true);
      }
    } catch (error) {
      toast.error(`error initiating save - ${error.message}`);
    } finally {
      setSaving(false);
    }
  };

  useEffect(() => {
    (async () => {
      try {
        const { ovest, dollar_wallet } = await $api.user.getBalances();

        setOvest(
          payload.payment_method === "dollar_wallet" ? dollar_wallet : ovest
        );
      } catch (error) {
        // error...
      }
    })();
  }, [setOvest, payload.payment_method]);

  return (
    <div className="startinvestment-body">
      <div className="startinvestment-main">
        <div className="confirminvestment-main">
          <h5 className="create-flexible-h5"> Save Now</h5>
          <p className="create-flexible-p">Choose Payment Method</p>
        </div>
        <div className="silverplan">
          <p className="fundwith-header">Fund With</p>
          <hr className="hr" />
          <div className="silverplan-flex">
            <div className="ovest-wallet">
              <p
                className="ovestwallet-main"
                style={{ textTransform: "capitalize" }}
              >
                {!isCard && payload.payment_method.replace("_", " ")}
                {isCard && payment.meta.name}
              </p>

              <div className="savestflexible-balance">
                {payload.payment_method.includes("_") && (
                  <p className="save-now-with-balance mt-3">
                    Balance: {currency}
                    {ovest}
                  </p>
                )}
                {isCard && (
                  <p className="save-now-with-balance mt-3">
                    ***** {payment.meta.last_four}
                  </p>
                )}
                <p
                  onClick={() => setMenu(11)}
                  className="save-now-change-payment"
                >
                  Change this{" "}
                  <span>
                    <img
                      src={backtick}
                      alt=""
                      className="ml-2"
                      onClick={() => setMenu(4)}
                    />
                  </span>{" "}
                </p>
              </div>
              {/* <p className="funds-p mt-5">
                Insufficient funds. <span>Fund wallet</span>
              </p> */}
            </div>
          </div>
        </div>
        <div className="note-main p-4">
          <p className="funds-deduction">
            Funds will be deducted automatically from your available payment
            method(s) on OVest.
          </p>
        </div>
        <button onClick={handleSaveClick} className="savest-button">
          Save now {currency} {Util.formatMoneyNumber(payload.amount_to_save)}
        </button>
        {/* <button className="claim-property">Save N500</button> */}
      </div>
      <SuccessModal
        message={`You have successfully saved N${Util.formatMoneyNumber(
          +payload.amount_to_save
        )} from your ${payload.payment_method.replace(
          "_",
          " "
        )} to your Savest account.`}
        url="/dashboard"
        onCloseClick={() => window.location.reload()}
        show={show}
      />
    </div>
  );
};

export default SaveNowFixed;
